import * as _ from "lodash";
function mapIfDefined(collection, iteratee) {
  return _.reduce(
    collection,
    (acc, c) => {
      const res = iteratee(c);
      if (res !== void 0) {
        acc.push(res);
      }
      return acc;
    },
    []
  );
}
function newListWithAddedOrRemovedItem(isAdd, existingList, item) {
  if (isAdd) {
    return [...existingList, item];
  } else {
    return _.filter(existingList, (o) => o !== item);
  }
}
export {
  mapIfDefined,
  newListWithAddedOrRemovedItem
};
//# sourceMappingURL=CollectionUtils.js.map
